import axiosInstance from "@/composables/axios-instance";

const state = {
  employees: [],
};

const getters = {
  getEmployeesList(state) {
    return state.employees;
  },
};

const mutations = {
  setEmployeesList(state, data) {
    state.employees = data;
  },
};

const actions = {
  getListOfEmployeesFromApi({ commit }) {
    return axiosInstance
      .get("/subset/list/")
      .then(response => {
        commit("setEmployeesList", response.data);
      })
      .catch(error => {
        console.error(error);
      });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
